<template>
  <div v-if="impersonationActive" class="impersonate-banner">
    {{
      $t("impersonateBanner.seePlatformLike", {
        name: currentUserName,
        platform: Config.isCompass ? "ET Compass" : "ET Connect",
      })
    }}
    <span
      class="link--white back-to-user-management-link"
      @click="stopImpersonationAndRedirect"
      data-test="impersonate-banner-link"
      >{{ $t("impersonateBanner.backToUserManagement") }}</span
    >
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useStopImpersonation } from "@/components/impersonate-banner/composables/stopImpersonation";
import Config from "../../common/config";

const authStore = useAuthStore();
const impersonationActive = computed(() => authStore.isImpersonationActive);

const currentUser = computed(() => authStore.currentUser);
const currentUserName = computed(
  () =>
    `${currentUser.value?.personalData?.firstname} ${currentUser.value?.personalData?.lastname}`,
);

const { stopImpersonationAndRedirect } = useStopImpersonation();
</script>

<style scoped lang="scss">
.impersonate-banner {
  width: 100%;
  padding: 8px;
  text-align: center;

  color: white;
  background: $color-etBlue;
}
</style>
